// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'slideshow';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M2.813 8.775 4.187 7.4a.729.729 0 0 1 1.03 0l.858.859a.729.729 0 0 0 1.03 0l2.045-2.04a.729.729 0 0 1 1.03 0l1.569 1.568a.73.73 0 0 0 1.03 0L15.187 5.4M8.856.563V1.64' />
    <path d='M16.688 1.641H1.313a.75.75 0 0 0-.75.75v10.313c0 .414.335.75.75.75h15.374a.75.75 0 0 0 .75-.75V2.39a.75.75 0 0 0-.75-.75zM9 13.454v2.25m-2.31 1.731L9 15.703l2.307 1.73' />
  </g>
);

export const viewBox = '0 0 18 18';
